import { LS, Cookie } from './storage';
import { SYNC_URL, CloudSync, SyncQueue, ActiveWorkoutStore } from './sync';
import { SessionManager } from './auth';
import { clearPhotoUrlCache } from './photoSign';
import { sameAccountSession } from './accountActions';

export const readAccountSession = () => ({ token: LS.get('ft-session-token'), email: LS.get('ft-session-email') });
export async function accountRequest(path, body, session) {
  if (!sameAccountSession(session, readAccountSession())) throw new Error('Session changed');
  const response = await fetch(`${SYNC_URL}${path}`, { method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Session-Token': session.token },
    body: JSON.stringify(body), signal: AbortSignal.timeout(15000) });
  return { ok: response.ok, body: await response.json().catch(() => null) };
}

// Both actions clear this browser only after a stable, explicit user action.
// Deletion callers arrive here only after the exact account's server success.
export async function finishAccountSession(session) {
  if (!sameAccountSession(session, readAccountSession())) return false;
  CloudSync.suspend();
  // Clear the two IndexedDB stores before exposing the sign-in screen. Keep the
  // current token until this finishes so a changed session aborts local cleanup.
  const stillCurrent = () => sameAccountSession(session, readAccountSession());
  const cleared = await SyncQueue.clear(stillCurrent);
  if (!sameAccountSession(session, readAccountSession())) return false;
  const draftCleared = await ActiveWorkoutStore.clear(stillCurrent);
  if (!sameAccountSession(session, readAccountSession())) return false;
  if (!cleared || !draftCleared) { CloudSync.resume(); throw new Error('Could not clear local offline data. Please retry before signing into another account.'); }
  // revoke clears credentials synchronously; its network request uses the captured
  // old token and cannot clear a later login when it finishes.
  void SessionManager.revoke({clearQueue:false});
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (key?.startsWith('ft-')) localStorage.removeItem(key);
  }
  Cookie.clear('ironlog_session');
  clearPhotoUrlCache();
  return true;
}
